import { Model } from "../alcance/models/model";
import { Edificacao } from "./edificacao";
import { Estabelecimento } from "./estabelecimento";
import { Modulo } from "./modulo";
import { Preco } from "./preco";
import { Venda } from "./venda";

export class Cliente extends Model{
    private _estabelecimento!: Estabelecimento;
    private _edificacao!: Edificacao;
    private _estabelecimentos!: Estabelecimento[];
    private _modulos!: Modulo[];
    private _liberacao!: ClienteLiberacao;

    conf: any;
    modular!: boolean;
    compras!: Venda[];

    get estabelecimento(): Estabelecimento {
        return this._estabelecimento ? this._estabelecimento : (this.estabelecimentos.length > 0 ? this.estabelecimentos[0] : null) as Estabelecimento;
    }

    set estabelecimento(e: Estabelecimento){
        this._estabelecimento = new Estabelecimento(e);
    }

    get estabelecimentos(): Estabelecimento[] {
        return this._estabelecimentos;
    }

    set estabelecimentos(e: Estabelecimento[]){
        let est: Estabelecimento[] = [];
        e.forEach((v) => {
            est.push(new Estabelecimento(v))
        })
        this._estabelecimentos = est;
    }

    get edificacao(): Edificacao{
        return this._edificacao ? this._edificacao : this.estabelecimento?.edificacoes[0];
    }

    set edificacao(e: Edificacao | null){
        this._edificacao = new Edificacao(e);
    }

    get edificacoes(): Edificacao[]{
        let eds: Edificacao[] = [];
        this.estabelecimentos.forEach(e => {
            eds = eds.concat(e.edificacoes);
        })
        return eds;
    }

    set modulos(m: Modulo[]){
        this._modulos = m;
    }

    get modulos(): Modulo[]{
        let mod: Modulo[] = [];
        this._modulos.forEach(m => {
            if(!mod.find(i => i.id == m.id))
                mod.push(m)
        })
        return mod;
    }

    get canAddEstabelecimento(): boolean{
        return this.modular ? (this.conf.modular.estabelecimentos === 0 || this.conf.modular.estabelecimentos > this.estabelecimentos.length) : true;
    }

    get canAddEdificacao(): boolean{
        return this.estabelecimento ? (this.modular ? (this.conf.modular.edificacoes === 0 || this.conf.modular.edificacoes > this.estabelecimento.edificacoes.length) : true) : false;
    }

    set liberacao(l: ClienteLiberacao){
        this._liberacao = l;
    }

    get liberacao(): ClienteLiberacao{
        return this._liberacao || {} as ClienteLiberacao;
    }

    // constructor(data : any){
    //     super(data);
    //     Object.assign(this, data);
    // }
}

export interface ClienteConf{
    modular: any;
    estoque: boolean;
}

export interface ClienteLiberacao{
    brigadistas_cadastrados: number;
    brigadistas_liberados: number;
    cliente_id: number;
    edificacoes_cadastrados: number;
    edificacoes_liberados: number;
    equipamentos_cadastrados: number;
    equipamentos_liberados: number;
    estabelecimentos_cadastrados: number;
    estabelecimentos_liberados: number;
    residentes_cadastrados: number;
    residentes_liberados: number;
    usuarios_cadastrados: number;
    usuarios_liberados: number;
    verificar: boolean;
    // updated_at:string
    // created_at:string
}